<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-box-sale-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>

<app-admin-box-sale-approve-modal
  (cancelEvent)="handleApproveModalCancel()"
  (confirmEvent)="handleApproveModalConfirm()"
  [isLoading]="approveStatusLoading()"
  [isSubmitting]="approveSubmitting()"
  [status]="approveStatus()"
  [visible]="approveModalVisible()" />
